/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailssubtitle2Inputs */

const en_companydetailssubtitle2 = /** @type {(inputs: Companydetailssubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is how your invoices are addressed.`)
};

const de_companydetailssubtitle2 = /** @type {(inputs: Companydetailssubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So steht es auf deinen Rechnungen.`)
};

/**
* | output |
* | --- |
* | "This is how your invoices are addressed." |
*
* @param {Companydetailssubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailssubtitle2 = /** @type {((inputs?: Companydetailssubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailssubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailssubtitle2(inputs)
	return de_companydetailssubtitle2(inputs)
});
export { companydetailssubtitle2 as "companyDetailsSubtitle" }